import { Button, StandardButtonProps } from '@platform/components';
import { AriaButtonOptions } from 'react-aria';

type CTACardProps = {
  title: string;
  description: string;
  ctaButtonProps: StandardButtonProps & AriaButtonOptions<'button'>;
};

export const CTACard = ({ title, description, ctaButtonProps }: CTACardProps) => {
  return (
    <div className='border border-gray-100 bg-secondary-brand-25 rounded-xl p-4 flex flex-col gap-2 text-center md:text-left'>
      <h3 className='text-md font-semibold'>{title}</h3>
      <p className='text-md mb-2'>{description}</p>
      <Button {...ctaButtonProps} additionalClassnames='w-fit mx-auto md:mx-0'>
        {ctaButtonProps.children}
      </Button>
    </div>
  );
};
